// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"9530f611","703":"7911c497","787":"e93c2c33"}[chunkId] + ".chunk.js";
};